import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disbursement-details" }
const _hoisted_2 = { class: "disbursement-detail-section" }
const _hoisted_3 = { class: "disbursement-detail" }
const _hoisted_4 = { class: "fw-700" }
const _hoisted_5 = { class: "disbursement-detail-section" }
const _hoisted_6 = { class: "disbursement-detail" }
const _hoisted_7 = { class: "fw-700" }
const _hoisted_8 = {
  ref: "disbAmountPopoverRef",
  id: "disbursement-amount",
  popover: ""
}

import Icon from "@/components/shared/Icon.vue";
import DisbursementAmountTotal from "@/components/certification-updates/DisbursementAmountTotal.vue";
import type { DisbursementGroupModel, DisbursementModelVM } from "@/models/disbursementService";
import type { CertificationModelVM } from "@/models/certificationService";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementSummary',
  props: {
    certification: {},
    disbursement: {},
    disbursementGroups: {}
  },
  setup(__props: any) {

const props = __props;

const disbursementGroup = computed<DisbursementGroupModel | undefined>(() => {
  if (!props.disbursementGroups || Object.keys(props.disbursementGroups)?.length === 0) {
    return undefined;
  }

  const filteredDisbGroups = props.disbursementGroups[`${props?.certification?.details?.status}`];

  if (filteredDisbGroups?.length > 0) {
    return filteredDisbGroups[0];
  }

  return undefined;
});

const estimatedDisbursementDate = computed<string>(() => {
  if (disbursementGroup.value) return disbursementGroup.value?.estimatedDisbursementDate;

  return props.disbursement?.estimatedDisbursementDate;
});

const lastUpdated = computed<string>(() => {
  if (disbursementGroup.value) return disbursementGroup.value?.lastUpdated;

  return props.disbursement?.lastUpdated;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "Status Last Updated: ", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(lastUpdated.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Estimated Disbursement Date: ", -1)),
        _createElementVNode("span", _hoisted_7, [
          _createTextVNode(_toDisplayString(estimatedDisbursementDate.value) + "  ", 1),
          _createVNode(Icon, {
            icon: "info-green",
            popovertarget: "disbursement-amount",
            "aria-describedby": "mobile-tip",
            color: "#008000",
            class: "anchor-btn"
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(DisbursementAmountTotal, {
              totalAmount: disbursementGroup.value?.totalAmountDisplay,
              count: disbursementGroup.value?.count || 0
            }, null, 8, ["totalAmount", "count"])
          ], 512)
        ])
      ])
    ])
  ]))
}
}

})